module.exports = __webpack_public_path__ + "img/trust.eab7c6cd.svg";